import { List } from 'immutable';
import StudentPaperBasedHomework from './StudentPaperBasedHomework';
import PaperBasedHomework from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'sessionId':
    case 'unitId':
      return [key, `${val}`];
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'studentPaperBasedHomeworks':
      return [key, new List(val.map((data) => StudentPaperBasedHomework.create(data)))];
    case 'studentTutorialHomeworks':
      return [key, new List(val.map((data) => StudentPaperBasedHomework.create(data)))];
    default:
      return [key, val];
  }
};
const create = (data) =>
  new PaperBasedHomework(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/PaperBasedHomework/create.js